import { WebSocketService } from './websocket-service';

export const websocketConnection = async (
    url,
    {
        onOpen = () => {},
        onClose = () => {},
        onError = () => {},
        onMessage = () => {},
        onStatusChange = () => {},
    } = {},
) => {
    let status = 'disconnected';

    console.log('Connecting to websocket', url);

    // Parse the URL to extract parameters
    const socketUrl = new URL(url);
    const channel = socketUrl.searchParams.get('channel');
    const auth = socketUrl.searchParams.get('auth');
    const token = socketUrl.searchParams.get('token');
    const channel_token = socketUrl.searchParams.get('channel_token');

    // Create connection info object
    const connectionInfo = {
        url: url,
        channel: channel,
        auth: auth,
        token: token,
        channel_token: channel_token,
    };

    // Create WebSocket service instance
    const wsService = new WebSocketService();

    // Connect with handlers
    const client = await wsService.connect(connectionInfo, {
        onOpen,
        onClose,
        onError,
        onMessage,
        onStatusChange: (newStatus) => {
            status = newStatus;
            onStatusChange(newStatus);
        },
    });

    // Return interface compatible with the previous implementation
    return {
        getStatus: () => status,
        close: () => wsService.close(),
    };
};
